import { ActionTree } from 'vuex'
import * as types from './types'
import api from '../api'
import router from '@/router'
import SubtleRSA from '@appbase/util/subtle-rsa'

export interface LoginActionPayload {
    comCode: string
    username: string
    password: string
}

export default <ActionTree<account.state.AccountState, RootState>>{
    async [types.LOGIN](action, payload: LoginActionPayload) {
        const result = await api.auth.login(payload.username, payload.password)
        action.commit(types.CURRENT, result)
        return result
    },

    async [types.LOGINEX](action, payload: LoginActionPayload) {
        const result = await api.auth.loginex(payload.username)
        action.commit(types.CURRENT, result)
        return result
    },

    async [types.LOGINHINT](action, payload: LoginActionPayload) {
        const result = await api.auth.loginHint(payload.username)
        action.commit(types.CURRENT, result)
        return result
    },

    async [types.LOGINASSERTION](action, payload: { username: string, userAssertion: string }) {
        const result = await api.auth.loginAssertion(payload.username, payload.userAssertion)
        action.commit(types.CURRENT, result)
        return result
    },

    async [types.LOGINGRAPH](action, payload: LoginActionPayload) {
        const publicKey = 'MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEA5kWA0b3PBDDWWGLOZl0Qm0b/1OHgSf8IqX/Xa8dd/v/RqS+qixRUOV/yf1DRNv2JreDBezPrsgEyUQGMjDnRDrMnqzxHRWJPFF+LVXDP5Rs9s6LkBcV8JAjRJC4c7O6ejORYoLOGvTzhJ1NLv4hsd8YnSKtNUaY3WL/Ju4G3JOouKYTDOQ6cXOB/+pRLkORSt16snO0LTKJGjlpZAKNHSirTO0EG9MFqoPnOOoKE4Wd/BU4vfh3dp4iQKCKfC4TvDo16iXpIQLqlOc9p0ekG7xc6ZlwEjdqAFi7heZDJc45tpywjVfnOPASMjm92iVEP8ZqJm05E8K/v/mnp/tWP2QIDAQAB';
        const rsa = new SubtleRSA(publicKey);
        await rsa.initialize();
        const encrypted = await rsa.encrypt(payload.password);

        const result = await api.auth.loginGraph(payload.comCode, payload.username, encrypted);
        action.commit(types.CURRENT, result)
        return result
    },

    async [types.CURRENT](action, payload) {
        const result = await api.account.getCurrentUser()
        action.commit(types.CURRENT, result)
        return result
    },

    async [types.LOGOUT](action, payload) {
        const result = await api.auth.logout()
        action.commit(types.CURRENT, null)
        router.push({ name: 'account-login' })
        return result
    }    
}
